import {BaseDTO} from '../../common/models/BaseDTO';
import {IssueTicketDetailsDTO} from './IssueTicketDetailsDTO';

export class IssueTicketDetailsLinkDTO extends BaseDTO {
  issueTicketDetail: IssueTicketDetailsDTO;
}
